import {
  CHART_TYPES,
  VISUALIZATION_TYPE,
} from "AIAnalytics/components/AIChart/modules/AIChartConstants";

export const CHART_DROPDOWN_KEYS = {
  BAR_CHART: CHART_TYPES.BAR_CHART,
  LINE_CHART: CHART_TYPES.LINE_CHART,
  PIE_CHART: CHART_TYPES.PIE_CHART,
  TABLE: VISUALIZATION_TYPE.Tabular,
  BOX_PLOT: CHART_TYPES.BOX_PLOT,
  STACKED_BAR_CHART: CHART_TYPES.STACKED_BAR_CHART,
};

export const AI_INSIGHTS_TABLE_TYPES = {
  UNDERLYING_DATA: "underlying_data",
  UNDERLYING_DATA_MODAL: "underlying_data_modal",
  GRAPH_DATA: "graph_data",
};

export const AI_INSIGHTS_HELP_CENTER_ARTICLE_URL =
  "https://support.toddleapp.com/en/articles/12951309-understanding-key-metrics-in-the-insights-module";
